<template>
  <el-card
    :body-style="bodyStyle"
    shadow="never"
    :class="[isCarousel ? 'carousel__width' : '', 'mb-40']"
    :style="{
      'background-color': available ? '' : '#80808057',
      'padding-top': available ? '' : '3px',
      'padding-bottom': available ? '' : '3px',
    }"
  >
    <!-- MOBILE: refactored 2-line layout (task 1212847320276818). Mobile-only;
         desktop keeps the column grid below unchanged.
         Line 1: pastille + wine name (truncated at 66%) .......... vintage
         Line 2: grape names (truncated at 66%) ......... UVC + price
         The pastille sits in a left gutter so name and grape align, and it
         visually separates products. No IP/SAQ square on mobile — the UVC
         takes that slot. -->
    <router-link
      v-if="isMobileLayout && product.slug"
      class="mobile-list-row"
      :to="productView"
    >
      <div class="mlr-pastille">
        <div class="circle" :style="{ background: pastilleColor }" />
      </div>
      <div class="mlr-content">
        <div class="mlr-line mlr-line--1">
          <span class="mlr-name">{{ productName }}</span>
          <span class="mlr-vintage">{{ releaseYear }}</span>
        </div>
        <div class="mlr-line mlr-line--2">
          <span class="mlr-grape">{{ grapeVarietiesName }}</span>
          <span class="mlr-right">
            <span class="mlr-uvc">{{ productVolume }}</span>
            <span
              v-if="inventoryLabel"
              class="inventory__label inventory mlr-inv"
            >{{ inventoryLabel }}</span>
            <span class="mlr-price price-html" v-html="price"></span>
          </span>
        </div>
      </div>
    </router-link>

    <el-row v-if="!isMobileLayout" :gutter="5" class="list-view">
      <router-link
        style="color: #000 !important"
        v-if="product.slug"
        :to="productView"
      >
        <el-col v-if="!isMobileLayout" :xs="circleXs" :sm="1" :md="1" class="product-circle text-left">
          <div class="circle mt-4" :style="{ background: pastilleColor }" />
        </el-col>
        <el-col :xs="0" :sm="12" :md="3" class="product-type mb-5" >
          {{ productTypeName }}
        </el-col>
        <el-col :xs="inventoryXs" :sm="2" :md="1" class="product-inventory">
          <!-- Always render the column (transparent placeholder when there's
            no label) so ON rows — which have no IP/SAQ square — stay
            right-aligned with the QC layout. -->
          <span
            v-if="!isMobileLayout && inventoryLabel"
            class="inventory__label inventory"
          >
            {{ inventoryLabel }}
          </span>
          <span class="inventory__label inventory" v-else style="background-color: transparent;"></span>
        </el-col>
        <el-col v-if="isMobileLayout" class="product-circle text-left mb-5" style="width: 100%; display: flex;">
          <div class="circle mt-2" :style="{ background: pastilleColor }" />
          <div class="text-left font-weight-bold product-title ml-5 text-truncate">{{ productName }}</div>
          <span class="varietyName ml-5">{{ grapeVarietiesName }}</span>
          
        </el-col>
        <el-col
          :xs="titleXs"
          :sm="24"
          :md="14"
          class="text-left font-weight-bold product-title d-flex "
          v-if="!isMobileLayout"
        >
          <span  class="product-list">{{ productName }}</span>
          <span class="varietyName ml-5">{{ grapeVarietiesName }}</span>
        </el-col>

        <el-col :xs="yearXs" :sm="4" :md="1" class="product-year">
          {{ releaseYear }}
        </el-col>
        <el-col :xs="volumeXs" :sm="4" :md="1" class="product-volume">
          {{ productVolume }}
        </el-col>
        <el-col v-if="!isMobileLayout" :xs="caisseXs" :sm="4" :md="1" class="d-flex product-caisse">
          {{ caisse }}
        </el-col>
      </router-link>
      
      <el-col :xs="inventoryXs" :sm="2" :md="1" class="product-inventory">
          <span
            v-if="inventoryLabel && isMobileLayout"
            class="inventory__label inventory"
          >
            {{ inventoryLabel }}
          </span>
        </el-col>
        <el-col :xs="priceXs" :sm="4" :md="2" class="product-price">
        <span class="price-html" v-html="price"></span>
      </el-col>
      <el-col
      v-if="!isMobileLayout"
        :xs="disponibiliteXs"
        :sm="4"
        :md="1"
        class="product-disponibilite"
      >
        <label class="disponibilite">{{ disponibilite }}</label>
      </el-col>
      <el-col
      v-if="!isMobileLayout"
        :xs="24"
        :sm="24"
        :md="24"
        :style="{ display: available ? 'block' : 'none' }"
      >
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { filter, get, head, isEmpty } from "@/utils/lodash";
import { formatCurrency, specialFormatCurrency } from "@/utils/common-utils";

import imgProductDefault from "@/assets/images/product/product-default.png";
import imgProductInventoryIp from "@/assets/images/product/product-inventory-ip.png";
import imgProductInventorySaq from "@/assets/images/product/product-inventory-saq.png";
import cssVariables from "@/assets/variables.scss";
import getRandomInt from "../../../mixins/getRandomInt";
import layoutUtils from "@/utils/layout-utils";
import { resolveProductCardVintage } from "@/utils/product-vintage-utils";
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    taxCode: {
      type: String,
      default: "IN",
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    productType: {
      type: String,
      default: null,
    },
    circleXs: {
      type: Number,
      default: 8,
    },
    typeNameXs: {
      type: Number,
      default: 8,
    },
    inventoryXs: {
      type: Number,
      default: 8,
    },
    titleXs: {
      type: Number,
      default: 24,
    },
    yearXs: {
      type: Number,
      default: 4,
    },
    volumeXs: {
      type: Number,
      default: 4,
    },
    caisseXs: {
      type: Number,
      default: 4,
    },
    priceXs: {
      type: Number,
      default: 4,
    },
    disponibiliteXs: {
      type: Number,
      default: 4,
    },
  },
  mixins: [getRandomInt],
  data() {
    return {
      bodyStyle: {
        padding: "0px",
      },
      images: {
        productDefault: {
          src: imgProductDefault,
        },
        productInventoryIp: {
          src: imgProductInventoryIp,
        },
        productInventorySaq: {
          src: imgProductInventorySaq,
        },
      },
      inventoryType: this.getInventoryType(),
      constants: {
        PRODUCT_COLOR: "PRODUCT_COLOR",
        WHITE: "WHITE",
        PALE_ORANGE: "PALE_ORANGE",
        ORANGE: "ORANGE",
        RAMATO: "RAMATO",
        PINK: "PINK",
        PALE_RED: "PALE_RED",
        RED: "RED",
        COLORLESS: "COLORLESS",
        AMBER: "AMBER",
        BLACK: "BLACK",
      },
      countryCode: localStorage.getItem("countryCode") || "QC",
    };
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    productView() {
      return {
        name: "product",
        params: {
          slug: get(this.product, "slug", ""),
          productType: this.productType,
        },
        query: {
          id: get(this.product, "puid")
            ? get(this.product, "puid")
            : get(this.product, "id").toString(),
          productType:
            get(this.product, "puid") && this.productType != ""
              ? this.productType
              : undefined,
          pid: get(this.product, "id").toString()
        },
      };
    },
    productName() {
      return get(this.product, "name");
    },
    productTypeName() {
      if (this.$i18n.locale == "fr-CA") {
        return (
          get(this.product.category, "name", "") + 
          " " +
          get(this.product.specificCategory, "name", "")
        );
      }
      return (
        get(this.product.specificCategory, "name", "") +
        " " +
        get(this.product.category, "name", "") 
        );
    },
    grapeVarietiesName() {
      const items = get(this.product, "technicalSpecs");
      var proper = filter(items, (items) => get(items, "properties"));
      var grapValue = "";
      var SearchVarible = "Cépage";
      if (this.$i18n.locale === "en-US") {
        SearchVarible = "Grape";
      }
      if (!isEmpty(proper)) {
        // Read the cépages of the CURRENTLY AVAILABLE vintage, not just the
        // first technical spec the API returns. Products with several vintages
        // (fiches techniques) can list different grapes per year; the card was
        // showing an out-of-stock vintage's grapes. Resolve the right spec the
        // same way the detail page and the card's own `releaseYear` do:
        // match currentTechnicalSpec.id, then the available vintage year, then
        // fall back to NV / most-recent, and finally the previous behaviour.
        var graps = this.currentSpec(proper).properties;
        let type = [];
        graps.forEach((value) => {
          if (value.label === SearchVarible) {
            grapValue = value.value.split(" ");
            grapValue.forEach((val) => {
              if (val.indexOf("%") > -1) return;
              type.push(val);
            });
            grapValue = type.join(" ");
          }
        });
      }
      return grapValue;
    },
    productVolume() {
      // Use the backend's pre-formatted label (same as the tile view), which
      // already renders "750ml", "1L", "1.5L" correctly. The previous
      // hand-rolled ml/L math assumed `volume` was always in millilitres and
      // mis-rendered litre-unit products (e.g. a 1L bottle stored as volume=1
      // showed up as "1ml").
      return get(this.product, "lblFormat") || "-";
    },
    releaseYear() {
      return resolveProductCardVintage(this.product);
    },
    price() {
      let price = get(this.product, "erpProduct.pricing.price", 0);
      let agencyFees = get(this.product, "erpProduct.pricing.agencyFee", 0);

      if (this.taxCode === "IN") {
        price = get(this.product, "erpProduct.pricing.priceTaxIn", 0);
        if (price === 0 || price == null)
          price = get(this.product, "erpProduct.pricing.price", 0);
        agencyFees = get(this.product, "erpProduct.pricing.agencyFeeWTaxes", 0);
      }

      if (price + agencyFees === 0) {
        return "N/A";
      }
      if (this.$i18n.locale == "fr-CA" || this.$i18n.locale == "en-US") {
        var formatPrice = specialFormatCurrency(
          price + agencyFees,
          this.$i18n.locale
        );
        if (this.$i18n.locale == "en-US") {
          formatPrice = formatPrice.split(".");
        } else {
          formatPrice = formatPrice.split(",");
        }
        if (formatPrice.length == 1) {
          formatPrice.push("00");
        }
        return `${
          formatPrice[0]
        }<span class="sub-price"> ${formatPrice[1]
          .toString()
          .padEnd(2, "0")}</span> $`;
      }
      return formatCurrency(price + agencyFees, this.$i18n.locale);
    },
    inventory() {
      if (this.inventoryType === "IP") {
        return this.images.productInventoryIp.src;
      }
      if (this.inventoryType === "SAQ") {
        return this.images.productInventoryIp.src;
      }
      if (this.inventoryType == null) {
        return this.images.productInventorySaq.src;
      }
      return null;
    },
    inventoryLabel() {
      const inventoryMapping = this.countryCode == 'ON' ? '' :
      // {
      //     IP: "CSMT",
      //     // SAQ: "LCBO",
      //     LCBO: "LCBO",
      //     STORE_TORONTO: "DIR",
      //     MERCH_TORONTO: 'DIR',
      //     PI: "DIR",
      //     Consignment: "PRI",
      //     null: "CSMT",
      //   } :
        {
          IP: "IP",
          SAQ: "SAQ",
          STORE_MTL: "DIR",
          Brouhh: "DIR",
          MERCH_MTL: "DIR",
          BERGEVILLE: "DIR",
          null: "",
        };
        return inventoryMapping[this.inventoryType] || "";
    },
    pastilleColor() {
      return this.getPastilleColor(this.getColorCode());
    },
    caisse() {
      const uvc = get(this.product, "uvc", 0);

      return this.$i18n.t(
        "products.listTypeViewHeading.productCardComponent.boxOf",
        {
          numberOfBottle: uvc,
        }
      );
    },
    disponibilite() {
      const nextBatches = get(this.product, "erpProduct.itemToCome", "");

      if (
        !get(this.product, "erpProduct.quantity.inStock") &&
        !nextBatches &&
        isEmpty(nextBatches)
      ) {
        return "-";
      }
      if (get(this.product, "erpProduct.quantity.inStock")) {
        // return "DISPO";
        return this.$i18n.t("common.dispo");
      }
      if (isEmpty(nextBatches)) {
        return this.$i18n.t("common.dispo");
      }
      if (nextBatches.receptionPlanningDate) {
        var date1 = new Date(nextBatches.receptionPlanningDate);
        var date2 = new Date();
        const month = date1.toLocaleString(this.$i18n.locale, {
          month: "short",
        });
        if (date1.getDate() < date2.getDate()) {
          return `${month.toUpperCase().substring(0, 3)}${date1
            .getFullYear()
            .toString()
            .slice(-2)}`;
        }
        return `${month.toUpperCase().substring(0, 3)}${date1
          .getFullYear()
          .toString()
          .slice(-2)}`;
      }
      return this.$i18n.t("common.dispo");
    },
    available() {
      return get(this.product, "erpProduct.quantity.inStock");
    },
  },
  methods: {
    // Pick the technical spec matching the currently displayed (available)
    // vintage so the list card shows that vintage's cépages. `specs` is the
    // already-filtered list of specs that have a `properties` array.
    currentSpec(specs) {
      const currentSpecId = get(this.product, "currentTechnicalSpec.id");
      if (currentSpecId != null) {
        const byId = specs.find((spec) => get(spec, "id") === currentSpecId);
        if (byId) return byId;
      }

      const vintage = resolveProductCardVintage(this.product);
      if (vintage != null && `${vintage}`.trim() !== "") {
        const byYear = specs.find(
          (spec) => `${get(spec, "releaseYear", "")}`.trim() === `${vintage}`.trim()
        );
        if (byYear) return byYear;
      }

      const sorted = [...specs].sort((a, b) => {
        const aYear = `${get(a, "releaseYear", "")}`;
        const bYear = `${get(b, "releaseYear", "")}`;
        if (aYear === "NV") return -1;
        if (bYear === "NV") return 1;
        return bYear.localeCompare(aYear, undefined, { numeric: true });
      });
      return head(sorted) || specs[0];
    },
    getColorCode() {
      const vm = this;
      const attributes = get(vm.product, "attributes");

      if (attributes != null) {
        const color = head(
          filter(
            attributes,
            (attribute) =>
              get(attribute, "type.code") === vm.constants.PRODUCT_COLOR
          )
        );

        if (color != null) {
          return color.code;
        }
      }

      return null;
    },
    getPastilleColor(code) {
      switch (code) {
        case this.constants.WHITE:
          return cssVariables.pastilleWhite;
        case this.constants.PALE_ORANGE:
          return cssVariables.pastilleOrangeLight;
        case this.constants.ORANGE:
          return cssVariables.pastilleOrange;
        case this.constants.RAMATO:
          return cssVariables.pastilleRamato;
        case this.constants.PINK:
          return cssVariables.pastilleRose;
        case this.constants.PALE_RED:
          return cssVariables.pastilleRedLight;
        case this.constants.RED:
          return cssVariables.pastilleRed;
        case this.constants.COLORLESS:
          return cssVariables.pastilleClear;
        case this.constants.AMBER:
          return cssVariables.pastilleAmber;
        case this.constants.BLACK:
          return cssVariables.pastilleBlack;
        default:
          return cssVariables.pastilleClear;
      }
    },
    getInventoryType() {
      return get(this.product, "inventory.code");
    },

    format_date(value) {
      var date = new Date(value);
      var result =
        "" +
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 > 9 ? "" : "0") +
        (date.getMonth() + 1) +
        "-" +
        (date.getDate() > 9 ? "" : "0") +
        date.getDate();
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>

@import "@/assets/variables.scss";
$carousel-image-size: 356px;
$carousel-image-size-mobile: 312px;

.list-view{
  margin-top: 3px;
}
.el-card {
  border-radius: 0px;
  border: 0;
  background-color: $color-background-area1;
  color: #333333;
  line-height: normal;
  margin: auto;
}
.product-background {
  border: 0 solid rgba(237, 240, 237, 0.33);
  background-color: rgba(237, 240, 237, 0.33);
}
.product__detail {
  height: 152px;

  & div {
    background-color: rgba(255, 255, 255, 0);
    color: rgba(39, 36, 33, 0.7);
    box-sizing: border-box;
    text-align: left;
    line-height: normal;
    font-weight: 400;
  }
}
.product__name {
  color: $color-on-background !important;
}
.product__price {
  color: #272421 !important;
  margin-top: 14px;
  margin-bottom: 39px;
}
.carousel__height {
  // sm -
  @media screen and (max-width: $media-md) {
    height: $carousel-image-size-mobile;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $carousel-image-size-mobile;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: $carousel-image-size;
  }
}
.carousel__width {
  // sm -
  @media screen and (max-width: $media-md) {
    width: $carousel-image-size-mobile;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $carousel-image-size-mobile;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $carousel-image-size;
  }
}
// .image-container {
//   position: relative;
// }
.circle {
  width: 12px;
  height: 12px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  background: red;
  margin-left: 5px;
}
.inventory__label {
  padding-top: 1px !important;
  order: 2;
  bottom: 1px;
  right: 18px;
  height: 16px;
  width: fit-content;
  line-height: normal;
  padding: 0px 4px;
}
.inventory {
  padding-top: 2px !important;
  padding-bottom: 2px;
  border-radius: 2px;
  border: 1px solid rgba(39, 36, 33, 0.33);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 700;
  color: rgba(39, 36, 33, 0.33);
  text-align: center;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 8px;
  color: #fff;
  background-color: #b4b3b2;
  border: 0;
}
.font-weight-bold {
  font-weight: 700;
}
.tbd {
  margin-top: -15px;
}
.disponibilite {
  font-size: 14px;
}
.varietyName {
  display: block;
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.product-list {
  white-space: nowrap;
}

/* Mobile list-view 2-line layout (task 1212847320276818). Scoped to mobile
   via the v-if in the template, so desktop is untouched. */
.mobile-list-row {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 2px 10px 2px 0;
  color: #000 !important;
  text-decoration: none;
}
.mlr-pastille {
  flex: 0 0 auto;
  padding-top: 3px;
  /* left gutter — the pastille sticks out so the two text lines align and the
     colour marks where one product ends and the next begins */
  .circle {
    margin-left: 5px;
    margin-right: 0;
  }
}
.mlr-content {
  flex: 1 1 auto;
  min-width: 0; /* lets the name/grape ellipsis-truncate inside the flex row */
  padding-left: 8px;
}
.mlr-line {
  display: flex;
  align-items: baseline;
  width: 100%;
}
.mlr-line--2 {
  margin-top: 1px; /* tight inter-line spacing */
}
.mlr-name {
  font-weight: 700;
  font-size: 14px;
  max-width: 66%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mlr-vintage {
  margin-left: auto;
  padding-left: 8px;
  white-space: nowrap;
  font-weight: 700;
  font-size: 13px;
}
.mlr-grape {
  font-size: 12px;
  font-weight: 400;
  color: rgba(39, 36, 33, 0.7);
  max-width: 66%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* right-hand cluster on line 2: provenance badge + UVC + price, kept together
   and pushed to the right edge (price sits under the vintage on line 1) */
.mlr-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.mlr-inv {
  flex: 0 0 auto;
  /* sit between the quantity (UVC) and the price — override the order:2 that
     .inventory__label carries for the desktop column layout */
  order: 0;
  margin-left: 8px;
}
.mlr-uvc {
  padding-left: 8px;
  white-space: nowrap;
  font-size: 12px;
  color: rgba(39, 36, 33, 0.7);
}
.mlr-price {
  padding-left: 8px;
  white-space: nowrap;
  font-weight: 700;
  font-size: 13px;
}

@media screen and (max-width: $media-md) {
  /* reduce the gap between cards on mobile (royal-blue arrows in the mockup) */
  .mb-40 {
    margin-bottom: 16px;
  }
}
</style>
